/* =========================================================
   Woody Keuzehulp
   Liquid: snippets/woody-keuzehulp.liquid
   CSS: assets/custom.css
========================================================= */

(function () {
  'use strict';

  var SELECTOR = '[data-woody-root]';

  function bootWoodyKeuzehulp() {
    document.querySelectorAll(SELECTOR).forEach(function (root) {
      if (root.dataset.woodyInit === '1') return;

      root.dataset.woodyInit = '1';
      initWoodyKeuzehulp(root);
    });
  }

  function initWoodyKeuzehulp(root) {
    var lang = root.dataset.woodyLang || 'nl';
    var mode = root.dataset.woodyMode || 'inline';

    var dictionary = getDictionary(lang);
    var config = getConfig(lang);

    var els = {
      steps: root.querySelector('[data-woody-steps]'),
      results: root.querySelector('[data-woody-results]'),
      top: root.querySelector('[data-woody-top]'),
      materials: root.querySelector('[data-woody-materials]'),
      materialList: root.querySelector('[data-woody-material-list]'),
      explain: root.querySelector('[data-woody-explain]'),
      ctas: root.querySelector('[data-woody-ctas]'),
      progress: root.querySelector('[data-woody-progress]'),
      city: root.querySelector('[data-woody-city]'),
      search: root.querySelector('[data-woody-search]'),
      overlay: root.querySelector('[data-woody-close]'),
      card: root.querySelector('.woody-keuzehulp__card')
    };

    if (!els.steps || !els.results || !els.top) {
      return;
    }

    var state = {
      currentStepId: config.steps[0].id,
      answers: {},
      score: {},
      mats: {},
      flags: {}
    };

    config.products.forEach(function (product) {
      state.score[product.id] = 0;
    });

    config.materials.forEach(function (material) {
      state.mats[material.id] = 0;
    });

    applyStaticTranslations(root, dictionary);

    if (els.city) {
      els.city.placeholder = dictionary.placeholder;
    }

    buildStep();

    root.querySelectorAll('[data-woody-restart]').forEach(function (btn) {
      btn.addEventListener('click', restart);
    });

    root.querySelectorAll('[data-woody-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.querySelectorAll('.woody-open').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(true);
      });
    });

    if (els.search) {
      els.search.addEventListener('click', runSearch);
    }

    if (els.city) {
      els.city.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          runSearch();
        }
      });
    }

    function buildStep() {
      var step = getStep(state.currentStepId);

      if (!step) {
        showResult();
        return;
      }

      els.results.hidden = true;
      els.steps.hidden = false;
      els.steps.innerHTML = '';

      updateProgress();

      var stepIndex = config.steps.findIndex(function (item) {
        return item.id === step.id;
      });

      var li = document.createElement('li');
      li.className = 'woody-keuzehulp__step';
      li.dataset.stepId = step.id;

      var head = document.createElement('div');
      head.className = 'woody-keuzehulp__step-head';

      var title = document.createElement('h3');
      title.textContent = step.title;

      var count = document.createElement('span');
      count.className = 'woody-keuzehulp__step-count';
      count.textContent = dictionary.step + ' ' + (stepIndex + 1) + ' ' + dictionary.of + ' ' + config.steps.length;

      head.appendChild(title);
      head.appendChild(count);
      li.appendChild(head);

      var optionsWrap = document.createElement('div');
      optionsWrap.className = 'woody-keuzehulp__options';

      step.options.forEach(function (option) {
        var label = document.createElement('label');
        label.className = 'woody-keuzehulp__option';

        var input = document.createElement('input');
        input.type = step.multiple ? 'checkbox' : 'radio';
        input.name = 'woody-' + step.id;
        input.value = option.id;

        var saved = state.answers[step.id];

        if (saved && saved.indexOf(option.id) !== -1) {
          input.checked = true;
        }

        var span = document.createElement('span');
        span.textContent = option.label;

        label.appendChild(input);
        label.appendChild(span);
        optionsWrap.appendChild(label);
      });

      li.appendChild(optionsWrap);

      var actions = document.createElement('div');
      actions.className = 'woody-keuzehulp__actions';

      var left = document.createElement('div');
      left.className = 'woody-keuzehulp__actions-left';

      var right = document.createElement('div');
      right.className = 'woody-keuzehulp__actions-right';

      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'woody-keuzehulp__ghost';
      back.textContent = dictionary.back;
      back.disabled = stepIndex === 0;
      back.addEventListener('click', goBack);

      var skip = document.createElement('button');
      skip.type = 'button';
      skip.className = 'woody-keuzehulp__ghost';
      skip.textContent = dictionary.skip;
      skip.addEventListener('click', function () {
        state.answers[step.id] = [];
        goNext(step);
      });

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'woody-keuzehulp__btn';
      next.textContent = step.toResult ? dictionary.result : dictionary.next;
      next.addEventListener('click', function () {
        var selected = Array.from(li.querySelectorAll('input:checked')).map(function (input) {
          return input.value;
        });

        if (step.required && selected.length === 0) {
          li.classList.add('is-shaking');
          window.setTimeout(function () {
            li.classList.remove('is-shaking');
          }, 250);
          return;
        }

        state.answers[step.id] = selected;
        goNext(step);
      });

      left.appendChild(back);

      if (!step.required) {
        left.appendChild(skip);
      }

      right.appendChild(next);

      actions.appendChild(left);
      actions.appendChild(right);
      li.appendChild(actions);

      els.steps.appendChild(li);

      window.requestAnimationFrame(function () {
        li.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    function goBack() {
      var currentIndex = config.steps.findIndex(function (step) {
        return step.id === state.currentStepId;
      });

      if (currentIndex <= 0) return;

      state.currentStepId = config.steps[currentIndex - 1].id;
      buildStep();
    }

    function goNext(step) {
      var selected = state.answers[step.id] || [];

      if (step.toResult) {
        showResult();
        return;
      }

      var nextId = null;

      selected.some(function (selectedId) {
        var option = step.options.find(function (item) {
          return item.id === selectedId;
        });

        if (option && option.to) {
          nextId = option.to;
          return true;
        }

        return false;
      });

      if (!nextId) {
        nextId = step.defaultTo || getNextStepId(step.id);
      }

      if (!nextId || nextId === 'result') {
        showResult();
        return;
      }

      state.currentStepId = nextId;
      buildStep();
    }

    function showResult() {
      recalcScores();

      els.steps.hidden = true;
      els.results.hidden = false;

      if (els.progress) {
        els.progress.style.width = '100%';
      }

      var ranked = Object.keys(state.score)
        .map(function (id) {
          var product = config.products.find(function (item) {
            return item.id === id;
          });

          return {
            id: id,
            points: state.score[id],
            product: product
          };
        })
        .filter(function (item) {
          return item.product;
        })
        .sort(function (a, b) {
          return b.points - a.points;
        });

      if (!ranked.some(function (item) { return item.points > 0; })) {
        ranked = config.products.map(function (product) {
          return {
            id: product.id,
            product: product,
            points: 1
          };
        });
      }

      var topProducts = ranked.slice(0, 4);
      renderProducts(topProducts);
      renderMaterials(topProducts);
      renderCtas();
      renderExplain();

      window.requestAnimationFrame(function () {
        els.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    function recalcScores() {
      state.score = {};
      state.mats = {};
      state.flags = {};

      config.products.forEach(function (product) {
        state.score[product.id] = 0;
      });

      config.materials.forEach(function (material) {
        state.mats[material.id] = 0;
      });

      Object.keys(state.answers).forEach(function (stepId) {
        var step = getStep(stepId);
        var selected = state.answers[stepId] || [];

        if (!step) return;

        selected.forEach(function (optionId) {
          var option = step.options.find(function (item) {
            return item.id === optionId;
          });

          if (!option) return;

          addScore(option.add);
          addMaterials(option.addMat);

          if (option.flags) {
            Object.assign(state.flags, option.flags);
          }
        });
      });
    }

    function addScore(scoreMap) {
      if (!scoreMap) return;

      Object.keys(scoreMap).forEach(function (key) {
        if (typeof state.score[key] !== 'number') return;
        state.score[key] += scoreMap[key];
      });
    }

    function addMaterials(materialMap) {
      if (!materialMap) return;

      Object.keys(materialMap).forEach(function (key) {
        if (typeof state.mats[key] !== 'number') return;
        state.mats[key] += materialMap[key];
      });
    }

    function renderProducts(items) {
      var maxPoints = Math.max.apply(null, items.map(function (item) {
        return item.points || 1;
      }));

      els.top.innerHTML = '';

      items.forEach(function (item, index) {
        var product = item.product;
        var percent = Math.max(18, Math.round((item.points / maxPoints) * 100));

        var card = document.createElement('div');
        card.className = 'woody-keuzehulp__product';

        card.innerHTML =
          '<div class="woody-keuzehulp__rank">#' + (index + 1) + '</div>' +
          '<div>' +
            '<div class="woody-keuzehulp__product-title">' + escapeHtml(product.name) + '</div>' +
            '<div class="woody-keuzehulp__meta">' + escapeHtml(product.tagline) + '</div>' +
            '<div class="woody-keuzehulp__match">' +
              '<div class="woody-keuzehulp__match-track">' +
                '<span class="woody-keuzehulp__match-fill" style="width:' + percent + '%"></span>' +
              '</div>' +
              '<span class="woody-keuzehulp__meta">' + percent + '% ' + dictionary.match + '</span>' +
            '</div>' +
          '</div>' +
          '<a class="woody-keuzehulp__btn" href="' + product.href + '">' + dictionary.view + '</a>';

        els.top.appendChild(card);
      });
    }

    function renderMaterials(topProducts) {
      var hasBoard = topProducts.some(function (item) {
        return item.id === 'serveerplank';
      });

      if (hasBoard) {
        state.mats.beuken += 99;
      }

      var rankedMats = Object.keys(state.mats)
        .map(function (id) {
          var material = config.materials.find(function (item) {
            return item.id === id;
          });

          return {
            id: id,
            material: material,
            points: state.mats[id]
          };
        })
        .filter(function (item) {
          return item.material && item.points > 0;
        })
        .sort(function (a, b) {
          return b.points - a.points;
        })
        .slice(0, 2);

      els.materialList.innerHTML = '';

      if (!rankedMats.length) {
        els.materials.hidden = true;
        return;
      }

      rankedMats.forEach(function (item) {
        var li = document.createElement('li');

        li.innerHTML =
          '<strong>' + escapeHtml(item.material.name) + '</strong>' +
          '<div>' + escapeHtml(item.material.note) + '</div>';

        els.materialList.appendChild(li);
      });

      els.materials.hidden = false;
    }

    function renderCtas() {
      var wanted = ['cityAll', 'products', 'contact'];

      if (state.flags.b2b) {
        wanted.splice(1, 0, 'b2b');
      }

      if (state.flags.retailer) {
        wanted.splice(1, 0, 'retailer');
      }

      if (state.flags.custom || state.flags.personalize) {
        wanted.splice(1, 0, 'custom');
      }

      var seen = {};
      els.ctas.innerHTML = '';

      wanted.forEach(function (key) {
        if (seen[key]) return;
        seen[key] = true;

        var cta = config.ctas[key];
        if (!cta) return;

        var a = document.createElement('a');
        a.className = 'woody-keuzehulp__link-btn';
        a.href = cta.href;
        a.textContent = cta.label;

        els.ctas.appendChild(a);
      });
    }

    function renderExplain() {
      var lines = [];

      Object.keys(state.answers).forEach(function (stepId) {
        var step = getStep(stepId);
        var selected = state.answers[stepId] || [];

        if (!step || !selected.length) return;

        selected.forEach(function (optionId) {
          var option = step.options.find(function (item) {
            return item.id === optionId;
          });

          if (option) {
            lines.push('• ' + option.label);
          }
        });
      });

      els.explain.textContent = dictionary.chosen + '\n' + (lines.length ? lines.join('\n') : dictionary.noChoice);
    }

    function restart() {
      state.currentStepId = config.steps[0].id;
      state.answers = {};
      state.flags = {};

      config.products.forEach(function (product) {
        state.score[product.id] = 0;
      });

      config.materials.forEach(function (material) {
        state.mats[material.id] = 0;
      });

      buildStep();
    }

    function runSearch() {
      if (!els.city) return;

      var value = els.city.value.trim();

      if (!value) return;

      window.location.href = config.searchUrl + encodeURIComponent(value);
    }

    function updateProgress() {
      if (!els.progress) return;

      var index = config.steps.findIndex(function (step) {
        return step.id === state.currentStepId;
      });

      var percent = Math.max(8, Math.round(((index + 1) / config.steps.length) * 100));

      els.progress.style.width = percent + '%';
    }

    function setOpen(open) {
      if (mode !== 'popup') return;

      root.classList.toggle('is-open', open);

      if (els.card) {
        els.card.setAttribute('aria-modal', open ? 'true' : 'false');
      }
    }

    function getStep(stepId) {
      return config.steps.find(function (step) {
        return step.id === stepId;
      });
    }

    function getNextStepId(stepId) {
      var index = config.steps.findIndex(function (step) {
        return step.id === stepId;
      });

      if (index === -1 || index >= config.steps.length - 1) {
        return 'result';
      }

      return config.steps[index + 1].id;
    }
  }

  function applyStaticTranslations(root, dictionary) {
    root.querySelectorAll('[data-woody-i18n]').forEach(function (el) {
      var key = el.dataset.woodyI18n;

      if (dictionary[key]) {
        el.textContent = dictionary[key];
      }
    });
  }

  function getDictionary(lang) {
    var data = {
      nl: {
        eyebrow: 'Keuzehulp',
        title: 'WoodWideCities Keuzehulp',
        subtitle: 'Ik ben Woody. Ik help je snel kiezen.',
        hint: 'Beantwoord een paar korte vragen. Dan tonen we wat het beste past.',
        restart: 'Opnieuw',
        restartFull: 'Opnieuw beginnen',
        back: 'Terug',
        next: 'Volgende',
        skip: 'Overslaan',
        result: 'Toon resultaat',
        resultEyebrow: 'Jouw beste match',
        resultTitle: 'Dit past bij jou',
        resultSub: 'Op basis van je keuzes raden we deze producten aan.',
        materialsTitle: 'Materiaaladvies',
        cityLabel: 'Zoek jouw stad of regio',
        searchBtn: 'Zoeken',
        summaryTitle: 'Hoe is dit gekozen?',
        view: 'Bekijk',
        match: 'match',
        step: 'Stap',
        of: 'van',
        chosen: 'Je koos:',
        noChoice: 'Geen keuze ingevuld.',
        placeholder: 'Bijv. Groningen'
      },
      en: {
        eyebrow: 'Gift finder',
        title: 'WoodWideCities Gift Finder',
        subtitle: 'I am Woody. I help you choose fast.',
        hint: 'Answer a few short questions. Then we show the best match.',
        restart: 'Restart',
        restartFull: 'Start again',
        back: 'Back',
        next: 'Next',
        skip: 'Skip',
        result: 'Show result',
        resultEyebrow: 'Your best match',
        resultTitle: 'This fits you best',
        resultSub: 'Based on your answers, we recommend these products.',
        materialsTitle: 'Material advice',
        cityLabel: 'Search your city or region',
        searchBtn: 'Search',
        summaryTitle: 'How was this chosen?',
        view: 'View',
        match: 'match',
        step: 'Step',
        of: 'of',
        chosen: 'You chose:',
        noChoice: 'No answer given.',
        placeholder: 'E.g. Groningen'
      },
      de: {
        eyebrow: 'Auswahlhilfe',
        title: 'WoodWideCities Auswahlhilfe',
        subtitle: 'Ich bin Woody. Ich helfe dir schnell weiter.',
        hint: 'Beantworte ein paar kurze Fragen. Danach zeigen wir die beste Wahl.',
        restart: 'Neu starten',
        restartFull: 'Von vorne beginnen',
        back: 'Zurück',
        next: 'Weiter',
        skip: 'Überspringen',
        result: 'Ergebnis anzeigen',
        resultEyebrow: 'Deine beste Wahl',
        resultTitle: 'Das passt zu dir',
        resultSub: 'Auf Basis deiner Antworten empfehlen wir diese Produkte.',
        materialsTitle: 'Materialtipp',
        cityLabel: 'Suche deine Stadt oder Region',
        searchBtn: 'Suchen',
        summaryTitle: 'Wie wurde das gewählt?',
        view: 'Ansehen',
        match: 'Match',
        step: 'Schritt',
        of: 'von',
        chosen: 'Du hast gewählt:',
        noChoice: 'Keine Antwort gewählt.',
        placeholder: 'Z. B. Groningen'
      },
      fr: {
        eyebrow: 'Aide au choix',
        title: 'Guide de choix WoodWideCities',
        subtitle: 'Je suis Woody. Je t’aide à choisir vite.',
        hint: 'Réponds à quelques questions. Nous montrons ensuite le meilleur choix.',
        restart: 'Recommencer',
        restartFull: 'Recommencer',
        back: 'Retour',
        next: 'Suivant',
        skip: 'Passer',
        result: 'Voir le résultat',
        resultEyebrow: 'Ton meilleur choix',
        resultTitle: 'Voici ce qui te convient',
        resultSub: 'Selon tes réponses, nous conseillons ces produits.',
        materialsTitle: 'Conseil matière',
        cityLabel: 'Cherche ta ville ou région',
        searchBtn: 'Chercher',
        summaryTitle: 'Comment ce choix est fait ?',
        view: 'Voir',
        match: 'match',
        step: 'Étape',
        of: 'sur',
        chosen: 'Tu as choisi :',
        noChoice: 'Aucune réponse choisie.',
        placeholder: 'Ex. Groningen'
      }
    };

    return data[lang] || data.nl;
  }

  function getConfig(lang) {
    var content = {
      nl: getDutchContent(),
      en: getEnglishContent(),
      de: getGermanContent(),
      fr: getFrenchContent()
    };

    var c = content[lang] || content.nl;

    return {
      searchUrl: '/search?type=product&options%5Bprefix%5D=last&q=',
      ctas: c.ctas,
      products: c.products,
      materials: c.materials,
      steps: c.steps
    };
  }

  function getDutchContent() {
    return {
      ctas: {
        cityAll: { label: 'Alle steden bekijken', href: '/pages/alle-steden' },
        products: { label: 'Ontdek alle collecties', href: '/collections/all' },
        b2b: { label: 'Relatiegeschenken bekijken', href: '/pages/relatiegeschenken' },
        retailer: { label: 'Retailer worden', href: '/pages/verkooppunt-worden' },
        custom: { label: 'Maatwerk aanvragen', href: '/pages/voor-bedrijven' },
        contact: { label: 'Hulp nodig? Neem contact op', href: '/pages/contact-opnemen' }
      },
      products: [
        { id: 'wandklok', name: 'Wandklok', tagline: 'Een stijlvol cadeau met tijd en stad in één.', href: '/collections/skyline-wandklokken' },
        { id: 'serveerplank', name: 'Serveerplank', tagline: 'Sterk voor borrel, keuken en cadeau.', href: '/collections/skyline-serveerplank' },
        { id: 'standing', name: 'Standing Skyline', tagline: 'Mooi op kast, plank of bureau.', href: '/collections/standing-skyline' },
        { id: 'wand', name: 'Wand Skyline', tagline: 'Groot aan de muur. Een echte blikvanger.', href: '/collections/skylines-wanddecoratie' },
        { id: 'onderzetters', name: 'Onderzetters', tagline: 'Klein, handig en leuk om te geven.', href: '/collections/skylines-onderzetters' },
        { id: 'telefoonhouder', name: 'Telefoonhouder', tagline: 'Handig op bureau en leuk met eigen stad.', href: '/collections/skylines-telefoonhouder' },
        { id: 'magneet', name: 'Magneet', tagline: 'Klein, leuk en makkelijk te sparen.', href: '/collections/skylines-magneten' },
        { id: 'merch', name: 'Merchandise', tagline: 'Voor fans van stad en streek.', href: '/collections/merchandise' }

        /*
        Tijdelijk uitgeschakeld:
        { id: 'desk', name: 'Desk Organizer', tagline: 'Voor een net en persoonlijk bureau.', href: '/collections/skyline-desk-organizer' }
        */
      ],
      materials: [
        { id: 'eiken', name: 'Eikenhout', note: 'Warm en tijdloos. Past bijna overal.' },
        { id: 'bamboe', name: 'Bamboe', note: 'Licht, fris en met duurzame look.' },
        { id: 'noten', name: 'Noten', note: 'Donker, chic en warm.' },
        { id: 'palissander', name: 'Palissander', note: 'Rijk, diep en opvallend.' },
        { id: 'zwart_hout', name: 'Zwart hout', note: 'Modern, krachtig en strak.' },
        { id: 'acryl_wit', name: 'Wit glanzend acryl', note: 'Clean, fris en modern.' },
        { id: 'acryl_zwart', name: 'Zwart glanzend acryl', note: 'Strak, luxe en sterk in contrast.' },
        { id: 'goud_metallic', name: 'Goud metallic', note: 'Warm, feestelijk en opvallend.' },
        { id: 'beuken', name: 'Beuken', note: 'Sterk en geschikt voor serveerplanken.' }
      ],
      steps: [
        {
          id: 's1',
          title: 'Waarvoor zoek je iets moois?',
          required: true,
          options: [
            { id: 'self', label: 'Voor mezelf of mijn interieur', to: 's2a', add: { wand: 2, standing: 2, wandklok: 2, telefoonhouder: 1 } },
            { id: 'gift', label: 'Als cadeau', to: 's2b', add: { standing: 2, onderzetters: 2, serveerplank: 3, wand: 1, magneet: 1 } },
            { id: 'b2b', label: 'Voor mijn bedrijf of organisatie', to: 's2c', add: { wand: 2, wandklok: 2, standing: 1, serveerplank: 1 }, flags: { b2b: true } },
            { id: 'retail', label: 'Voor verkoop in mijn winkel', to: 'result', add: { merch: 2, wand: 2, standing: 2 }, flags: { retailer: true } },
            { id: 'idk', label: 'Weet ik nog niet', to: 's3', add: {} }
          ]
        },
        {
          id: 's2a',
          title: 'Wat wil je graag in huis?',
          multiple: true,
          options: [
            { id: 'muur', label: 'Een eyecatcher voor aan de muur', to: 's3', add: { wand: 3, wandklok: 2 } },
            { id: 'tafel', label: 'Iets moois voor tafel of bureau', to: 's3', add: { standing: 2, onderzetters: 2, telefoonhouder: 2 } },
            { id: 'persoonlijk', label: 'Een persoonlijke skyline', to: 's3', add: { wand: 2, standing: 2 }, flags: { personalize: true } },
            { id: 'praktisch', label: 'Iets kleins en praktisch', to: 's3', add: { telefoonhouder: 2, onderzetters: 2, magneet: 1 } }
          ]
        },
        {
          id: 's2b',
          title: 'Voor welke gelegenheid?',
          multiple: true,
          options: [
            { id: 'bday', label: 'Verjaardag', to: 's3', add: { standing: 2, onderzetters: 1, serveerplank: 2 } },
            { id: 'house', label: 'Housewarming', to: 's3', add: { serveerplank: 3, wand: 2, onderzetters: 2 } },
            { id: 'farewell', label: 'Jubileum of afscheid', to: 's3', add: { wandklok: 3, wand: 2 } },
            { id: 'xmas', label: 'Kerst of feestdag', to: 's3', add: { onderzetters: 2, serveerplank: 2, standing: 2 } },
            { id: 'smallgift', label: 'Klein bedankje', to: 's3', add: { magneet: 3, onderzetters: 2 } }
          ]
        },
        {
          id: 's2c',
          title: 'Waar wil je het zakelijk voor gebruiken?',
          multiple: true,
          options: [
            { id: 'giftbiz', label: 'Relatiegeschenk', to: 's3', add: { serveerplank: 2, wandklok: 2, wand: 2 }, flags: { b2b: true } },
            { id: 'staff', label: 'Voor collega’s of personeel', to: 's3', add: { wandklok: 2, standing: 2, onderzetters: 2 }, flags: { b2b: true } },
            { id: 'promo', label: 'Promotie of marketing', to: 's3', add: { merch: 3, magneet: 2 }, flags: { b2b: true } },
            { id: 'region', label: 'Voor gemeente, provincie of regio', to: 's3', add: { wand: 3, wandklok: 2 }, flags: { b2b: true } }
          ]
        },
        {
          id: 's3',
          title: 'Wat spreekt je het meest aan?',
          multiple: true,
          options: [
            { id: 'hang', label: 'Ophangen aan de muur', to: 's4', add: { wand: 3, wandklok: 2 } },
            { id: 'stand', label: 'Staand model', to: 's4', add: { standing: 3 } },
            { id: 'small', label: 'Klein en handig', to: 's4', add: { onderzetters: 2, telefoonhouder: 2, magneet: 2 } },
            { id: 'big', label: 'Groot en opvallend', to: 's4', add: { wand: 3, wandklok: 3 } },
            { id: 'clock', label: 'Een klok', to: 's4', add: { wandklok: 4 } },
            { id: 'board', label: 'Een serveerplank', to: 's4', add: { serveerplank: 4 } }
          ]
        },
        {
          id: 's4',
          title: 'Welke uitstraling past het best?',
          multiple: true,
          options: [
            { id: 'warm', label: 'Warm en natuurlijk', to: 's5', addMat: { eiken: 3 } },
            { id: 'lux', label: 'Luxe en stijlvol', to: 's5', addMat: { noten: 3, palissander: 2 } },
            { id: 'light', label: 'Licht en fris', to: 's5', addMat: { bamboe: 3, acryl_wit: 1 } },
            { id: 'dark', label: 'Donker en krachtig', to: 's5', addMat: { zwart_hout: 3, acryl_zwart: 1 } },
            { id: 'modern', label: 'Modern en strak', to: 's5', addMat: { acryl_wit: 2, acryl_zwart: 2 } },
            { id: 'gold', label: 'Feestelijk en opvallend', to: 's5', addMat: { goud_metallic: 3 } }
          ]
        },
        {
          id: 's5',
          title: 'Wil je het extra persoonlijk maken?',
          toResult: true,
          options: [
            { id: 'std', label: 'Nee, standaard is goed', add: {} },
            { id: 'engrave', label: 'Ja, met tekst of gravure', add: { standing: 1, wand: 1, serveerplank: 1 }, flags: { personalize: true } },
            { id: 'custom', label: 'Ja, met logo of maatwerk skyline', add: { wand: 1, wandklok: 1 }, flags: { custom: true } }
          ]
        }
      ]
    };
  }

  function getEnglishContent() {
    var c = getDutchContent();

    c.ctas = {
      cityAll: { label: 'View all cities', href: '/pages/alle-steden' },
      products: { label: 'Explore all collections', href: '/collections/all' },
      b2b: { label: 'View business gifts', href: '/pages/relatiegeschenken' },
      retailer: { label: 'Become a retailer', href: '/pages/verkooppunt-worden' },
      custom: { label: 'Request custom work', href: '/pages/voor-bedrijven' },
      contact: { label: 'Need help? Contact us', href: '/pages/contact-opnemen' }
    };

    c.products[0].name = 'Wall Clock';
    c.products[0].tagline = 'A stylish gift with time and city in one.';
    c.products[1].name = 'Serving Board';
    c.products[1].tagline = 'Great for drinks, kitchens and gifts.';
    c.products[2].name = 'Standing Skyline';
    c.products[2].tagline = 'Great on a shelf, cabinet or desk.';
    c.products[3].name = 'Wall Skyline';
    c.products[3].tagline = 'Large wall decor with real impact.';
    c.products[4].name = 'Coasters';
    c.products[4].tagline = 'Small, useful and easy to gift.';
    c.products[5].name = 'Phone Stand';
    c.products[5].tagline = 'Useful on a desk with your own city.';
    c.products[6].name = 'Magnet';
    c.products[6].tagline = 'Small, fun and easy to collect.';
    c.products[7].name = 'Merchandise';
    c.products[7].tagline = 'For fans of city and region.';

    c.steps[0].title = 'What are you looking for?';
    c.steps[0].options[0].label = 'For myself or my home';
    c.steps[0].options[1].label = 'As a gift';
    c.steps[0].options[2].label = 'For my company or group';
    c.steps[0].options[3].label = 'To sell in my store';
    c.steps[0].options[4].label = 'I am not sure yet';

    c.steps[1].title = 'What would you like at home?';
    c.steps[1].options[0].label = 'A wall eye-catcher';
    c.steps[1].options[1].label = 'Something nice for table or desk';
    c.steps[1].options[2].label = 'A personal skyline';
    c.steps[1].options[3].label = 'Something small and useful';

    c.steps[2].title = 'What is the occasion?';
    c.steps[2].options[0].label = 'Birthday';
    c.steps[2].options[1].label = 'Housewarming';
    c.steps[2].options[2].label = 'Anniversary or farewell';
    c.steps[2].options[3].label = 'Christmas or holiday';
    c.steps[2].options[4].label = 'Small thank-you gift';

    c.steps[3].title = 'What is the business use?';
    c.steps[3].options[0].label = 'Business gift';
    c.steps[3].options[1].label = 'For staff or colleagues';
    c.steps[3].options[2].label = 'Promotion or marketing';
    c.steps[3].options[3].label = 'For city, region or province';

    c.steps[4].title = 'What do you like most?';
    c.steps[4].options[0].label = 'Wall mounted';
    c.steps[4].options[1].label = 'Standing model';
    c.steps[4].options[2].label = 'Small and useful';
    c.steps[4].options[3].label = 'Large and striking';
    c.steps[4].options[4].label = 'A clock';
    c.steps[4].options[5].label = 'A serving board';

    c.steps[5].title = 'Which look fits best?';
    c.steps[5].options[0].label = 'Warm and natural';
    c.steps[5].options[1].label = 'Luxury and stylish';
    c.steps[5].options[2].label = 'Light and fresh';
    c.steps[5].options[3].label = 'Dark and bold';
    c.steps[5].options[4].label = 'Modern and clean';
    c.steps[5].options[5].label = 'Festive and striking';

    c.steps[6].title = 'Do you want to make it personal?';
    c.steps[6].options[0].label = 'No, standard is fine';
    c.steps[6].options[1].label = 'Yes, with text or engraving';
    c.steps[6].options[2].label = 'Yes, with logo or custom skyline';

    return c;
  }

  function getGermanContent() {
    var c = getEnglishContent();

    c.ctas = {
      cityAll: { label: 'Alle Städte ansehen', href: '/pages/alle-steden' },
      products: { label: 'Alle Kollektionen entdecken', href: '/collections/all' },
      b2b: { label: 'Firmengeschenke ansehen', href: '/pages/relatiegeschenken' },
      retailer: { label: 'Händler werden', href: '/pages/verkooppunt-worden' },
      custom: { label: 'Maßarbeit anfragen', href: '/pages/voor-bedrijven' },
      contact: { label: 'Hilfe nötig? Kontakt aufnehmen', href: '/pages/contact-opnemen' }
    };

    c.products[0].name = 'Wanduhr';
    c.products[1].name = 'Servierbrett';
    c.products[2].name = 'Standing Skyline';
    c.products[3].name = 'Wand Skyline';
    c.products[4].name = 'Untersetzer';
    c.products[5].name = 'Handyhalter';
    c.products[6].name = 'Magnet';
    c.products[7].name = 'Merchandise';

    c.steps[0].title = 'Wofür suchst du etwas Schönes?';
    c.steps[0].options[0].label = 'Für mich oder mein Zuhause';
    c.steps[0].options[1].label = 'Als Geschenk';
    c.steps[0].options[2].label = 'Für meine Firma oder Organisation';
    c.steps[0].options[3].label = 'Zum Verkauf in meinem Laden';
    c.steps[0].options[4].label = 'Ich weiß es noch nicht';

    c.steps[1].title = 'Was möchtest du zu Hause haben?';
    c.steps[1].options[0].label = 'Einen Blickfang für die Wand';
    c.steps[1].options[1].label = 'Etwas Schönes für Tisch oder Schreibtisch';
    c.steps[1].options[2].label = 'Eine persönliche Skyline';
    c.steps[1].options[3].label = 'Etwas Kleines und Nützliches';

    c.steps[2].title = 'Für welchen Anlass?';
    c.steps[2].options[0].label = 'Geburtstag';
    c.steps[2].options[1].label = 'Einweihung';
    c.steps[2].options[2].label = 'Jubiläum oder Abschied';
    c.steps[2].options[3].label = 'Weihnachten oder Feiertag';
    c.steps[2].options[4].label = 'Kleines Dankeschön';

    c.steps[3].title = 'Wofür möchtest du es geschäftlich nutzen?';
    c.steps[4].title = 'Was spricht dich am meisten an?';
    c.steps[5].title = 'Welche Ausstrahlung passt am besten?';
    c.steps[6].title = 'Möchtest du es persönlicher machen?';

    c.steps[6].options[0].label = 'Nein, Standard ist gut';
    c.steps[6].options[1].label = 'Ja, mit Text oder Gravur';
    c.steps[6].options[2].label = 'Ja, mit Logo oder eigener Skyline';

    return c;
  }

  function getFrenchContent() {
    var c = getEnglishContent();

    c.ctas = {
      cityAll: { label: 'Voir toutes les villes', href: '/pages/alle-steden' },
      products: { label: 'Voir toutes les collections', href: '/collections/all' },
      b2b: { label: 'Voir les cadeaux d’entreprise', href: '/pages/relatiegeschenken' },
      retailer: { label: 'Devenir revendeur', href: '/pages/verkooppunt-worden' },
      custom: { label: 'Demander du sur-mesure', href: '/pages/voor-bedrijven' },
      contact: { label: 'Besoin d’aide ? Contacte-nous', href: '/pages/contact-opnemen' }
    };

    c.products[0].name = 'Horloge murale';
    c.products[1].name = 'Planche de service';
    c.products[2].name = 'Standing Skyline';
    c.products[3].name = 'Skyline murale';
    c.products[4].name = 'Sous-verres';
    c.products[5].name = 'Support téléphone';
    c.products[6].name = 'Aimant';
    c.products[7].name = 'Merchandise';

    c.steps[0].title = 'Pour quoi cherches-tu un bel objet ?';
    c.steps[0].options[0].label = 'Pour moi ou mon intérieur';
    c.steps[0].options[1].label = 'Comme cadeau';
    c.steps[0].options[2].label = 'Pour mon entreprise ou organisation';
    c.steps[0].options[3].label = 'Pour vendre dans ma boutique';
    c.steps[0].options[4].label = 'Je ne sais pas encore';

    c.steps[1].title = 'Que veux-tu chez toi ?';
    c.steps[1].options[0].label = 'Un bel objet mural';
    c.steps[1].options[1].label = 'Un objet pour table ou bureau';
    c.steps[1].options[2].label = 'Une skyline personnelle';
    c.steps[1].options[3].label = 'Quelque chose de petit et utile';

    c.steps[2].title = 'Pour quelle occasion ?';
    c.steps[2].options[0].label = 'Anniversaire';
    c.steps[2].options[1].label = 'Pendaison de crémaillère';
    c.steps[2].options[2].label = 'Jubilé ou départ';
    c.steps[2].options[3].label = 'Noël ou fête';
    c.steps[2].options[4].label = 'Petit remerciement';

    c.steps[3].title = 'Quel est l’usage professionnel ?';
    c.steps[4].title = 'Qu’est-ce qui te plaît le plus ?';
    c.steps[5].title = 'Quel style convient le mieux ?';
    c.steps[6].title = 'Veux-tu le rendre plus personnel ?';

    c.steps[6].options[0].label = 'Non, la version standard suffit';
    c.steps[6].options[1].label = 'Oui, avec texte ou gravure';
    c.steps[6].options[2].label = 'Oui, avec logo ou skyline sur mesure';

    return c;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWoodyKeuzehulp);
  } else {
    bootWoodyKeuzehulp();
  }

  document.addEventListener('shopify:section:load', bootWoodyKeuzehulp);
})();